import { render, staticRenderFns } from "./service-support-description-total.vue?vue&type=template&id=1656ad88&"
import script from "./service-support-description-total.vue?vue&type=script&lang=js&"
export * from "./service-support-description-total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports